export default "__VITE_ASSET__OMBwljSM__"